
import React from "react";
import { cn } from "@/lib/utils";

interface TerminalOutputProps {
  children: React.ReactNode;
  className?: string;
  prompt?: string;
  command?: string;
  error?: boolean;
  colorful?: boolean;
}

export default function TerminalOutput({
  children,
  className,
  prompt,
  command,
  error = false,
  colorful = false,
}: TerminalOutputProps) {
  const textColorClass = error
    ? "text-terminal-pink"
    : colorful
    ? ""
    : "text-foreground";

  return (
    <div className={cn("mb-2", className)}>
      {prompt && command && (
        <div className="flex items-start space-x-2 mb-1">
          <span className="text-terminal-green">{prompt}</span>
          <span className="text-foreground">{command}</span>
        </div>
      )}
      <div className={cn("pl-0", textColorClass)}>{children}</div>
    </div>
  );
}
